import Vue from 'vue'
import Router from 'vue-router'

import index from '@/pages/index'
import about from '@/pages/about'
import help from '@/pages/help'
import helpDetail from '@/pages/helpDetail'
import rule from '@/pages/rule'
import downLoad from '@/pages/downLoad'
import language from '@/pages/language'
import quicklyBuyCoins from '@/pages/quicklyBuyCoins'
import quicklyBuyCoinsDetail from '@/pages/quicklyBuyCoinsDetail'
import credit from '@/pages/credit'
import reg from '@/pages/reg'
import login from '@/pages/login'
import notice from '@/pages/notice'
import bannerDetail from '@/pages/bannerDetail'
import forgetPwd from '@/pages/forgetPwd'
import city from '@/pages/city'
import agreement from '@/pages/agreement' //贷币协议
import agreementApp from '@/pages/agreementApp'
import modifyPwd from '@/pages/modifyPwd'
import setWithdrawPwd from '@/pages/setWithdrawPwd'
import accountRecords from '@/pages/accountRecords'
import primaryCertification from '@/pages/primaryCertification' //初级认证
import advancedCertification from '@/pages/advancedCertification' //高级认证
import authentication from '@/pages/authentication' //身份认证

import user from '@/pages/user'
import set from '@/pages/set'
import records from '@/pages/records' //充币记录
import withdrawRecords from '@/pages/withdrawRecords' //提币记录
import securityCenter from '@/pages/securityCenter'
import quotes from '@/pages/quotes' //行情
import currencyTrading from '@/pages/currencyTrading' //币币交易
import contractTransaction from '@/pages/contractTransaction' //合约交易
import myAssets from '@/pages/myAssets'
import deposit from '@/pages/deposit' //充币
import withdraw from '@/pages/withdraw' //提币
import selectCurrency from '@/pages/selectCurrency' //选择币种
import propagate from '@/pages/propagate' //持币生息
import propagateBuy from '@/pages/propagateBuy' //持币生息购买
import currency from '@/pages/currency' //贷币
import currencyRecord from '@/pages/currencyRecord' //贷币
import userAgreement from '@/pages/userAgreement' //用户协议
import userAgreementApp from '@/pages/userAgreementApp' //用户协议
import repayment from '@/pages/repayment'
import repayment2 from '@/pages/repayment2'
import subscription from '@/pages/subscription' //新币申购
import subscribe from '@/pages/subscribe' //新币申购
import subscriptionList from '@/pages/subscriptionList' //新币申购
import orderStatus from '@/pages/orderStatus' //持币生息订单状态
import perpetualContract from '@/pages/perpetualContract' //永续合约
import kline from '@/pages/kline'
import positionList from '@/pages/positionList' //持仓列表
import delegateList from '@/pages/delegateList' //委托列表
import bindMail from '@/pages/bindMail' //邮箱认证
import security from '@/pages/security' //密保问题
import securityModPwd from '@/pages/securityModPwd' //密保问题修改密码
import addressAuth from '@/pages/addressAuth' //地址认证
import profitLoss from '@/pages/profitLoss' //止盈止损
import quickReg from '@/pages/quickReg' //快捷注册
import selectPropagateCurrency from '@/pages/selectPropagateCurrency' //选择持币生息币种
import service from '@/pages/service' //客服

import capital from '@/pages/capital/capital' //验资
import results from '@/pages/capital/results' //结果
import verification from '@/pages/capital/verification' //验资
import sign from '@/pages/sign' //签到
import signRule from '@/pages/signRule' //签到规则
import benefits from '@/pages/benefits' //福利专区
import benefitsDetail from '@/pages/benefitsDetail' //福利专区

import preciousMetal from '@/pages/preciousMetal' //贵金属
import trading from '@/pages/trading' //贵金属交易大厅
import contractOrder from '@/pages/contractOrder' //贵金属订单
import setProfit from '@/pages/setProfit' //贵金属设置止盈止损
import contractTransaction2 from '@/pages/contractTransaction2' //贵金属交割
import positionList2 from '@/pages/positionList2' //贵金属交割列表

Vue.use(Router)

export default new Router({
  linkActiveClass:'active',
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: index,
      meta: {
        // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/index',
      name: '首页',
      component: index,
      meta: {
        // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
    },
    {
      path: '/help',
      name: 'help',
      component: help,
    },
    {
      path: '/helpDetail',
      name: 'helpDetail',
      component: helpDetail,
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule,
    },
    {
      path: '/downLoad',
      name: 'downLoad',
      component: downLoad,
    },
    {
      path: '/language',
      name: 'language',
      component: language,
    },
    {
      path: '/city',
      name: 'city',
      component: city,
    },
    {
      path: '/quicklyBuyCoins',
      name: 'quicklyBuyCoins',
      component: quicklyBuyCoins,
    },
    {
      path: '/quicklyBuyCoinsDetail',
      name: 'quicklyBuyCoinsDetail',
      component: quicklyBuyCoinsDetail,
    },
    {
      path: '/credit',
      name: 'credit',
      component: credit,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/reg',
      name: 'reg',
      component: reg,
    },
    {
      path: '/quickReg',
      name: 'quickReg',
      component: quickReg,
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice,
    },
    {
      path: '/bannerDetail',
      name: 'bannerDetail',
      component: bannerDetail,
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      component: forgetPwd,
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
    },
    {
      path: '/agreementApp',
      name: 'agreementApp',
      component: agreementApp,
    },
    {
      path: '/modifyPwd',
      name: 'modifyPwd',
      component: modifyPwd,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/setWithdrawPwd',
      name: 'setWithdrawPwd',
      component: setWithdrawPwd,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/accountRecords',
      name: 'accountRecords',
      component: accountRecords,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/primaryCertification',
      name: 'primaryCertification',
      component: primaryCertification,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/advancedCertification',
      name: 'advancedCertification',
      component: advancedCertification,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/authentication',
      name: 'authentication',
      component: authentication,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/set',
      name: 'set',
      component: set,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/records',
      name: 'records',
      component: records,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/withdrawRecords',
      name: 'withdrawRecords',
      component: withdrawRecords,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/securityCenter',
      name: 'securityCenter',
      component: securityCenter,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/quotes',
      name: 'quotes',
      component: quotes,
    },
    {
      path: '/currencyTrading',
      name: 'currencyTrading',
      component: currencyTrading,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/contractTransaction',
      name: 'contractTransaction',
      component: contractTransaction,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/myAssets',
      name: 'myAssets',
      component: myAssets,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: withdraw,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/deposit',
      name: 'deposit',
      component: deposit,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/selectCurrency',
      name: 'selectCurrency',
      component: selectCurrency,
    },
    {
      path: '/propagate',
      name: 'propagate',
      component: propagate,
    },
    {
      path: '/currency',
      name: 'currency',
      component: currency,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/currencyRecord',
      name: 'currencyRecord',
      component: currencyRecord,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement,
    },
    {
      path: '/userAgreementApp',
      name: 'userAgreementApp',
      component: userAgreementApp,
    },
    {
      path: '/repayment',
      name: 'repayment',
      component: repayment,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/repayment2',
      name: 'repayment2',
      component: repayment2,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/subscription',
      name: 'subscription',
      component: subscription,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      component: subscribe,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/subscriptionList',
      name: 'subscriptionList',
      component: subscriptionList,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/orderStatus',
      name: 'orderStatus',
      component: orderStatus,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/propagateBuy',
      name: 'propagateBuy',
      component: propagateBuy,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/perpetualContract',
      name: 'perpetualContract',
      component: perpetualContract,
    },
    {
      path: '/kline',
      name: 'kline',
      component: kline,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/positionList',
      name: 'positionList',
      component: positionList,
    },
    {
      path: '/delegateList',
      name: 'delegateList',
      component: delegateList,
    },
    {
      path: '/bindMail',
      name: 'bindMail',
      component: bindMail,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/security',
      name: 'security',
      component: security,
    },
    {
      path: '/securityModPwd',
      name: 'securityModPwd',
      component: securityModPwd,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/addressAuth',
      name: 'addressAuth',
      component: addressAuth,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/profitLoss',
      name: 'profitLoss',
      component: profitLoss,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/selectPropagateCurrency',
      name: 'selectPropagateCurrency',
      component: selectPropagateCurrency,
    },
    {
      path: '/service',
      name: 'service',
      component: service,
    },
    {
      path: '/capital',
      name: 'capital',
      component: capital,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/results',
      name: 'results',
      component: results,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/verification',
      name: 'verification',
      component: verification,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/sign',
      name: 'sign',
      component: sign,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/signRule',
      name: 'signRule',
      component: signRule,
    },
    {
      path: '/benefits',
      name: 'benefits',
      component: benefits,
    },
    {
      path: '/benefitsDetail',
      name: 'benefitsDetail',
      component: benefitsDetail,
    },
    {
      path: '/preciousMetal',
      name: 'preciousMetal',
      component: preciousMetal,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/trading',
      name: 'trading',
      component: trading,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/contractOrder',
      name: 'contractOrder',
      component: contractOrder,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/setProfit',
      name: 'setProfit',
      component: setProfit,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/contractTransaction2',
      name: 'contractTransaction2',
      component: contractTransaction2,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/positionList2',
      name: 'positionList2',
      component: positionList2,
      meta: {
        requireAuth: true
      }
    },
    {
      path:'/',
      redirect:'index'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js